import $i18n from '@/locales/i18n';
import omit from 'lodash/omit';
import { createGroupCard } from '@/common/manager/setter-snippet';
import { replaceNode } from '@/common/util/block';
const { CnButton, CnMessage, CnBox } = window?.CNUI || {};
const UpdateSetter = ({ target }) => {
    return (<CnBox spacing={12} padding={[0, 12]}>
      {CnMessage && (<CnMessage iconType="horn-fill" type="warning" title={$i18n.get({
                id: 'ComponentSpecificationUpgradeRem_1563193482',
                dm: '组件规范升级提醒',
            })}>
          {$i18n.get({
                id: 'TheOriginalTitleRightButtonBarAn_730410342',
                dm: '原「标题」、「右侧按钮栏」、「筛选栏插槽」功能已整合至卡片组件，请点击下方按钮一键升级',
            })}
        </CnMessage>)}
      {CnButton && (<CnButton type="primary" style={{
                width: '100%',
                background: 'radial-gradient(179% 179% at 111% -31%, #4161FD 45%, #279DFD 100%)',
            }} onClick={() => {
                const currentNode = target?.getNode?.();
                const title = target?.parent?.getPropValue('normalStyle')?.title;
                const componentSlot = target?.parent?.getPropValue('_layout')?.componentSlot;
                const extra = target?.parent?.getPropValue('extra');
                const sectionProps = currentNode.schema.props;
                const newSectionProps = omit({
                    ...sectionProps,
                    normalStyle: omit(sectionProps?.normalStyle, ['title']),
                    _layout: omit(sectionProps?._layout, ['componentSlot']),
                }, 'extra');
                const cardSnippet = createGroupCard({
                    title,
                    headerBottomSlot: componentSlot,
                    buttons: extra,
                    children: [
                        {
                            ...currentNode.schema,
                            props: newSectionProps,
                        },
                    ],
                });
                replaceNode(currentNode, cardSnippet);
            }}>
          {$i18n.get({ id: 'OneclickUpgrade', dm: '一键升级' })}
        </CnButton>)}
    </CnBox>);
};
export default UpdateSetter;
